var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"webview-test"},[_c('button',{on:{"click":_vm.webviewLogin}},[_vm._v("웹뷰 로그인")])])
}
var staticRenderFns = []

export { render, staticRenderFns }